
// SVG Icon: take-the-tour
export default { id: "terriajs-take-the-tour" };
export const id = "terriajs-take-the-tour";
export const name = "take-the-tour";
